export default __webpack_public_path__ + "static/media/creative_directions_m.99fec2ab.jpg";